const messages = {
    availPoints: "Dostupni bodovi",
    awaitingPoints: "Bodovi na čekanju",
  board: {
    title: "Nadzorna ploča",
    title2: "Animacija performansi {year}",
    headline1: "Vaše promocije i bodovi na prvi pogled",
    headline2: "Zaradite bodove za kupnju guma.",
    pointsBalanceToDate: "STANJE BODOVA NA DAN",
    availPoints: "Dostupni bodovi",
    awaitingPoints: "Bodovi na čekanju",
    yourRealisation: "VAŠA POSTIGNUĆA",
    yourEngagement: "Vaša godišnja obveza: <b>{tyres} gume</b>",
    yourPoints: "VAŠI BODOVI",
    yourRetailPurchase: "VAŠA MALOPRODAJNA KUPNJA",
    yourRetailPurchaseCCS: "VAŠA MALOPRODAJA",
    pointsByPurchase: "bodovi generirani vašim kupnjama",
    pointsByBoosters: "bodovi koje generiraju pojačivači",
    pointsByBSPurchase: "Bodovi generirani vašim Bridgestone kupnjama",
    pointsByBSPurchaseCCS:
      "Bodovi generirani vašom prodajom guma Bridgestone",
    remaining: "Preostale gume",
    yourGoal: "Napredak cilja",
    unit: "gume",
    buttons: {
      learnMore: "Saznajte više o svojim bodovima",
      learnMoreAboutMechanism: "Saznajte više o mehanici",
    },
    charts: {
      byBrand: "Po marki",
      bySize: "Prema veličini<br/>naplataka",
    },
    exploreResults: "Otkrijte svoje rezultate",
    tyreLimitInfo:
      "Za svako razdoblje Booster kampanje potrebna je minimalna rasprodana količina od 50 Bridgestone i/ili Firestone guma",
  },
  charts: {
    byBrand: "Po marki",
    bySize: "prema veličini naplatka",
  },

  dashboard: {
    dashboardTitle: "Vaše pogodnosti",
    dashboardBox: {
      title: "Bilans bodova",
      description: "Vaš trenutni ukupan broj marketinških bodova",
      availPoints: "Dostupni bodovi",
      awaitingPoints: "Bodovi na čekanju",
      lastUpdate: "Zadnje ažuriranje",
      button: "Saznajte više",
      points: "bodovi",
    },
  },
  soldTyres: "GUME PRODANE",
  receivedPoints: "OSVOJENI BODOVI",
  boosterCCS: {
    personalInfo: "Osobni podaci",
    csNumberTitle: "Navedite broj/ove računa koji sudjeluju",
    tyresTitle: "Molimo navedite broj prodanih guma",
    minTyresInfo:
      "Potrebne su najmanje {tyres} Bridgestone/Firestone gume. Kompenzacija se odnosi samo na Bridgestone gume.",
    tyresAmount: "Broj guma",
    filesTitle: "Molimo prenesite svoj dokaz o prodaji",
    filesDescription:
      "Imajte na umu: u obzir će se uzeti samo prodaja u kojoj je navedena veličina naplatka.",
    addAnotherFile: "Dodajte drugi dokument",
    file: "Učitaj dokument",
    formatInfo:
      "Prihvaćeni formati datoteka: xlsx, jpeg i pdf. Maksimalna veličina datoteke: 8 MB",
    confrimationMessage:
      "<b>Hvala vam na vašem sudjelovanju!</b> <br/>Vaš zahtjev je primljen i proslijeđen Bridgestone timovima na provjeru.<br/>Primit ćete obavijest e-poštom s rezultatima vašeg sudjelovanja u Booster CCS.<br/>Vidimo se uskoro na Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Podijelite bodove",
    forShare: "Bodovi koje ćete podijeliti",
    title: "Titula",
  },
  notFoundFile: "Ništa odabrano",
  chooseFile: "Odaberite datoteku",
};
export default {
  messages,
};
